import { getApiUrl, request } from '@/utils/ajax';
import type { AddOptionPresetImageRequest, OptionPresetImageDto } from './option-preset-image.types';

export function addOptionPresetImage(presetId: number, payload: AddOptionPresetImageRequest): Promise<OptionPresetImageDto> {
    return request(`api/option-preset/${presetId}/images`, {
        method: 'POST',
        json: true,
        body: {
            SortOrder: payload.sortOrder,
            FileData: payload.fileData,
        },
    }).then((x) => x.json());
}

export function deleteOptionPresetImage(imageId: number): Promise<any> {
    return request(`api/option-preset/images/${imageId}`, {
        method: 'DELETE',
    });
}

// When `showroomPath` is provided, the URL points at the anonymous showroom-scoped preset-image
// endpoint, which re-validates the path components and that the image belongs to the same project
// as the resolved unit. Without it, returns the auth-gated /api/option-preset/images URL.
// Mirrors getProjectCatalogProductFileUrl in services/project-catalog.ts.
export function getOptionPresetImageUrl(imageId: number, options?: { showroomPath?: string | null }) {
    if (options?.showroomPath) {
        return `${getApiUrl()}/api/showroom/${options.showroomPath}/preset-image/${imageId}`;
    }
    return getApiUrl() + `/api/option-preset/images/${imageId}`;
}

export function getOptionPresetImageThumbnailUrl(imageId: number, options?: { showroomPath?: string | null }) {
    if (options?.showroomPath) {
        return `${getApiUrl()}/api/showroom/${options.showroomPath}/preset-image/${imageId}/thumbnail`;
    }
    return getApiUrl() + `/api/option-preset/images/${imageId}/thumbnail`;
}

export function setOptionPresetImageOrder(presetId: number, imageIdsInOrder: number[]): Promise<any> {
    return request(`api/option-preset/${presetId}/images/order`, {
        method: 'PUT',
        json: true,
        body: {
            ImageIdsInOrder: imageIdsInOrder,
        },
    });
}
